import React from "react";
import { Link, useLocation } from "../components/Router";
import { useSessionContext } from "../components/Session";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import "../sass/mobile-footer.scss";
import { CODEBUILD_BUILD_NUMBER, CODEBUILD_GIT_SHORT_ID } from "api-config";

const AdminDebugInfo = () => {
  return (
    <>
      <p className="copy-right-text pt-4">
        Build: {CODEBUILD_BUILD_NUMBER} Commit: {CODEBUILD_GIT_SHORT_ID}
      </p>
    </>
  );
};

const isActive = (currentPath, pathToCheck) => {
  if (currentPath === pathToCheck) {
    return "active";
  }
  return "";
};

const MobileFooter = () => {
  const { sessionContext } = useSessionContext();
  const { isAdminUser } = sessionContext;
  const { pathname } = useLocation();

  return (
    <>
      <div className="mobile-bottom-nav d-md-none d-none">
        <Container>
          <Row>
            <Col xs={12}>
              <div className="bottom-nav">
                <div className={`list-item ${isActive(pathname, "/")}`}>
                  <Link to="/">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="27.375"
                      height="27"
                      viewBox="0 0 25.375 25"
                    >
                      <path
                        className="stroke"
                        d="M22.38,10l0,0L13,.62A2.117,2.117,0,0,0,10,.62L.624,10l-.009.01a2.116,2.116,0,0,0,1.409,3.607q.032,0,.065,0h.374v6.9A2.481,2.481,0,0,0,4.941,23H8.612a.674.674,0,0,0,.674-.674V16.912a1.132,1.132,0,0,1,1.131-1.131h2.165a1.132,1.132,0,0,1,1.131,1.131v5.413a.674.674,0,0,0,.674.674h3.671a2.481,2.481,0,0,0,2.478-2.478v-6.9h.347A2.118,2.118,0,0,0,22.38,10Zm0,0"
                        transform="translate(1.188 1.001)"
                        fill="none"
                        strokeWidth="2"
                        opacity="0.86"
                      />
                    </svg>
                  </Link>
                </div>
                <div className={`list-item ${isActive(pathname, "/search")}`}>
                  <Link to="/search">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24.206"
                      height="25"
                      viewBox="0 0 22.206 23"
                    >
                      <path
                        className="fill"
                        d="M22.852,20.949l-5.474-5.693a9.283,9.283,0,1,0-7.108,3.316,9.187,9.187,0,0,0,5.32-1.68l5.516,5.736a1.211,1.211,0,1,0,1.746-1.679ZM10.27,2.422A6.864,6.864,0,1,1,3.407,9.286,6.871,6.871,0,0,1,10.27,2.422Z"
                        transform="translate(-0.984)"
                        opacity="0.86"
                      />
                    </svg>
                  </Link>
                </div>
                <div className={`list-item ${isActive(pathname, "/calendar")}`}>
                  <Link to="/calendar">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="25"
                      height="25"
                      viewBox="0 0 23 23"
                    >
                      <g transform="translate(0)" opacity="0.86">
                        <g transform="translate(0)">
                          <g>
                            <path
                              className="fill"
                              d="M20.3,1.8H19.227V0h-1.8V1.8H5.57V0h-1.8V1.8H2.7A2.7,2.7,0,0,0,0,4.492V20.3A2.7,2.7,0,0,0,2.7,23H20.3A2.7,2.7,0,0,0,23,20.3V4.492A2.7,2.7,0,0,0,20.3,1.8ZM21.2,20.3a.9.9,0,0,1-.9.9H2.7a.9.9,0,0,1-.9-.9V8.445H21.2Zm0-13.656H1.8V4.492a.9.9,0,0,1,.9-.9H3.773v1.8h1.8v-1.8H17.43v1.8h1.8v-1.8H20.3a.9.9,0,0,1,.9.9Z"
                            />
                          </g>
                        </g>
                        <g transform="translate(3.169 10.456)">
                          <g transform="translate(0 0)">
                            <rect
                              className="fill"
                              width="1.698"
                              height="2.087"
                            />
                          </g>
                        </g>
                        <g transform="translate(6.633 10.456)">
                          <g transform="translate(0 0)">
                            <rect
                              className="fill"
                              width="2.087"
                              height="2.087"
                              transform="translate(0 0)"
                            />
                          </g>
                        </g>
                        <g transform="translate(10.456 10.456)">
                          <g transform="translate(0 0)">
                            <rect
                              className="fill"
                              width="2.087"
                              height="2.087"
                              transform="translate(0 0)"
                            />
                          </g>
                        </g>
                        <g transform="translate(14.279 10.456)">
                          <g transform="translate(0 0)">
                            <rect
                              className="fill"
                              width="2.087"
                              height="2.087"
                              transform="translate(0 0)"
                            />
                          </g>
                        </g>
                        <g transform="translate(18.347 10.456)">
                          <g transform="translate(0 0)">
                            <rect
                              className="fill"
                              width="1.713"
                              height="2.087"
                            />
                          </g>
                        </g>
                        <g transform="translate(3.169 13.324)">
                          <g>
                            <rect
                              className="fill"
                              width="1.698"
                              height="2.087"
                            />
                          </g>
                        </g>
                        <g transform="translate(6.633 13.324)">
                          <g transform="translate(0 0)">
                            <rect
                              className="fill"
                              width="2.087"
                              height="2.087"
                              transform="translate(0)"
                            />
                          </g>
                        </g>
                        <g transform="translate(10.456 13.324)">
                          <g transform="translate(0 0)">
                            <rect
                              className="fill"
                              width="2.087"
                              height="2.087"
                            />
                          </g>
                        </g>
                        <g transform="translate(14.279 13.324)">
                          <g transform="translate(0 0)">
                            <rect
                              className="fill"
                              width="2.087"
                              height="2.087"
                              transform="translate(0)"
                            />
                          </g>
                        </g>
                        <g transform="translate(3.169 17.146)">
                          <g>
                            <rect
                              className="fill"
                              width="1.698"
                              height="2.087"
                            />
                          </g>
                        </g>
                        <g transform="translate(6.633 17.146)">
                          <g transform="translate(0 0)">
                            <rect
                              className="fill"
                              width="2.087"
                              height="2.087"
                              transform="translate(0)"
                            />
                          </g>
                        </g>
                        <g transform="translate(10.456 17.146)">
                          <g transform="translate(0 0)">
                            <rect
                              className="fill"
                              width="2.087"
                              height="2.087"
                            />
                          </g>
                        </g>
                        <g transform="translate(14.279 17.146)">
                          <g transform="translate(0 0)">
                            <rect
                              className="fill"
                              width="2.087"
                              height="2.087"
                              transform="translate(0)"
                            />
                          </g>
                        </g>
                        <g transform="translate(18.347 13.324)">
                          <g>
                            <rect
                              className="fill"
                              width="1.713"
                              height="2.087"
                            />
                          </g>
                        </g>
                      </g>
                    </svg>
                  </Link>
                </div>
                <div className={`list-item ${isActive(pathname, "/login")}`}>
                  <Link to="/login">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="21.589"
                      height="25.4"
                      viewBox="0 0 19.589 23.4"
                    >
                      <g id="user" transform="translate(0.2 0.2)">
                        <path
                          className="fill stroke"
                          d="M92.543,11.158a5.3,5.3,0,0,0,3.9-1.635,5.433,5.433,0,0,0,1.614-3.945,5.433,5.433,0,0,0-1.615-3.945,5.462,5.462,0,0,0-7.793,0,5.432,5.432,0,0,0-1.615,3.945,5.433,5.433,0,0,0,1.615,3.945A5.3,5.3,0,0,0,92.543,11.158ZM89.594,2.594a4.133,4.133,0,0,1,5.9,0,4.059,4.059,0,0,1,1.222,2.985,4.059,4.059,0,0,1-1.222,2.985,4.132,4.132,0,0,1-5.9,0,4.058,4.058,0,0,1-1.222-2.985,4.058,4.058,0,0,1,1.222-2.985Zm0,0"
                          transform="translate(-83.094 0)"
                          strokeWidth="0.4"
                        />
                        <path
                          className="fill stroke"
                          d="M19.142,253.939a13.873,13.873,0,0,0-.186-1.464A11.6,11.6,0,0,0,18.6,251a7.3,7.3,0,0,0-.6-1.372,5.17,5.17,0,0,0-.906-1.189,3.99,3.99,0,0,0-1.3-.823,4.469,4.469,0,0,0-1.661-.3,1.679,1.679,0,0,0-.9.385c-.27.177-.586.382-.938.609a5.356,5.356,0,0,1-1.214.538,4.681,4.681,0,0,1-2.969,0A5.34,5.34,0,0,1,6.9,248.31c-.349-.225-.665-.43-.939-.609a1.678,1.678,0,0,0-.9-.385,4.463,4.463,0,0,0-1.661.3,3.987,3.987,0,0,0-1.3.823,5.171,5.171,0,0,0-.905,1.189A7.31,7.31,0,0,0,.589,251a11.628,11.628,0,0,0-.357,1.471,13.779,13.779,0,0,0-.186,1.464c-.031.442-.046.9-.046,1.368a3.861,3.861,0,0,0,1.134,2.91,4.066,4.066,0,0,0,2.923,1.074H15.132a4.067,4.067,0,0,0,2.923-1.074,3.859,3.859,0,0,0,1.134-2.91c0-.467-.016-.927-.047-1.368Zm-2.017,3.295a2.737,2.737,0,0,1-1.994.7H4.057a2.737,2.737,0,0,1-1.994-.7,2.522,2.522,0,0,1-.716-1.927c0-.434.014-.863.043-1.274a12.428,12.428,0,0,1,.168-1.318,10.255,10.255,0,0,1,.314-1.3,5.951,5.951,0,0,1,.489-1.116,3.833,3.833,0,0,1,.666-.879,2.647,2.647,0,0,1,.866-.542,3.083,3.083,0,0,1,1.061-.206c.047.025.131.074.267.163.277.182.6.389.95.616a6.655,6.655,0,0,0,1.523.686,6.019,6.019,0,0,0,3.8,0,6.663,6.663,0,0,0,1.524-.686c.361-.233.672-.434.949-.616.136-.089.22-.138.267-.163a3.084,3.084,0,0,1,1.062.206,2.65,2.65,0,0,1,.865.542,3.823,3.823,0,0,1,.666.879,5.931,5.931,0,0,1,.489,1.116,10.232,10.232,0,0,1,.314,1.3,12.533,12.533,0,0,1,.168,1.319h0c.029.41.043.838.043,1.273a2.521,2.521,0,0,1-.716,1.927Zm0,0"
                          transform="translate(0 -236.291)"
                          strokeWidth="0.4"
                        />
                      </g>
                    </svg>
                  </Link>
                </div>
              </div>
            </Col>
          </Row>
          {/* {isAdminUser && <AdminDebugInfo />} */}
        </Container>
      </div>
    </>
  );
};

export default MobileFooter;
